import { render, staticRenderFns } from "./EmployerPricing.vue?vue&type=template&id=1169d75a"
import script from "./EmployerPricing.vue?vue&type=script&lang=ts"
export * from "./EmployerPricing.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports